module.exports = __webpack_public_path__ + "static/cosyclambmain-94359e0d9bc184540ed5e63328b83310.jpeg";